import React, { createContext, useState, useEffect } from 'react';
// import { Navigate } from 'react-router-dom';

// Создаем контекст
export const AuthContext = createContext();

// Провайдер контекста
export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [currentUserProfile, setCurrentUserProfile] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
 

  // Функция для получения текущего пользователя
  const fetchCurrentUser = async () => {
    try {
           // 1) Берём токен из localStorage
     const token = localStorage.getItem('user_token');
     let headers = {};
     if (token) {
       headers['Authorization'] = `Bearer ${token}`;
     }
      const response = await fetch('/api/current_user', {
        credentials: 'include',  // Включаем куки для сессии
        headers
      });
  
      const data = await response.json();
      setLoading(false);

      if (!data.authorized) {
        setCurrentUser(null);
      setCurrentUserProfile(null);  // Сбрасываем профиль
        // Пользователь не авторизован
        console.log('User is not authorized');
        
        // setCurrentUser(null);
      } else { if (!data.userprofile) {
        // Пользователь авторизован
        setCurrentUserProfile(null);
        setCurrentUser(data);
        setRole(data.user_role);
        console.log('User is not profile');
        
      } else {
        // Пользователь авторизован
        setCurrentUser(data);
        setCurrentUserProfile(data.userprofile);
        setRole(data.user_role);
        console.log(data.userprofile);
      } 
      }
      
    } catch (error) {
      console.error('Error fetching user:', error);
    }
  };

  
   

  // Выполняем получение текущего пользователя при монтировании компонента
  useEffect(() => {
    fetchCurrentUser();
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, fetchCurrentUser, setCurrentUser, currentUserProfile, setCurrentUserProfile, role ,loading}}>
      {children}
    </AuthContext.Provider>
  );
};
